import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define LanguageState interface
export interface LanguageState {
  currentLanguage: string;
  defaultLanguage: string;
  supportedLanguages: string[];
  languageNames: Record<string, string>;
}

// Get initial language data from themeVariables
const languageData = window.themeVariables?.language || {
  current: "tr",
  default: "tr",
  supported: ["tr, en"],
  names: { tr: "Türkçe", en: "English" },
};

const initialState: LanguageState = {
  currentLanguage: languageData.current,
  defaultLanguage: languageData.default,
  supportedLanguages: languageData.supported,
  languageNames: languageData.names,
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setCurrentLanguage: (state, action: PayloadAction<string>) => {
      // Only update if it's a supported language
      if (state.supportedLanguages.includes(action.payload)) {
        state.currentLanguage = action.payload;
      }
    },
    // We could add more actions later if needed
  },
});

export const { setCurrentLanguage } = languageSlice.actions;

export default languageSlice.reducer;
